<script>
import VehicleInfoComponent from '@/components/VehicleInfoComponent'
import RightLayout from '@/router/layouts/rightLayout'
export default {
  components: { VehicleInfoComponent, RightLayout }
}
</script>

<template>
<right-layout>
  <vehicle-info-component
  :title="'車両ブロック設定'"
  :btnName="'設定'"
  :type="'block'"
  :func="'setting'"
  ></vehicle-info-component>
</right-layout>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleSetting.vue